module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-text-fill-277b6c9e.svg";